<life-di-nav></life-di-nav>
<lifedi-breadcrumb *ngIf="news" [lastPath]="news.NEWS_TITAL"></lifedi-breadcrumb>

<div class="container" *ngIf="news && suggestNews">
  <h1>{{news.NEWS_TITAL}}</h1>
  <div class="row justify-content-between">
    <div class="col-12 mb-2">
      <h6 style="display: inline-block;">จำนวนการอ่าน {{news.NEWS_READED}} ครั้ง</h6>
      <h6 [class.d-none]="news.AlWAYS_OPEN == 'true'" style="display: inline-block; float: right;">
        วันที่ {{ news.NEWS_DATE | date }}
      </h6>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <img [src]="news.NEWS_PIC" style="width: 100%;">
    </div>
  </div>
  <div class="row" *ngIf="suggestNews.length > 0">
    <div class="col-lg-9 col-md-12 col-sm-12 col-12 mt-4">
      <div [innerHtml]="newsDetails" id="_content"
        style="line-height: 2; width: 100%; background: white; padding: 30px;">
      </div>
    </div>
    <div class="col-lg-3 col-md-12 col-sm-12 col-12 p-3">
      <h4 class="mt-3">เรื่องที่คุณอาจสนใจ</h4>
      <div class="row">
        <div *ngFor="let item of suggestNews" class="mt-4 col-lg-12 col-md-6 col-sm-6 col-12">
          <lifedi-card-box (click)="viewSuggest(item.NEWS_ID)" [title]="item.NEWS_TITAL" [imageUrl]="item.NEWS_PIC"
            [content]="item.NEWS_DETAIL" [id]="item.NEWS_ID" style="outline: none;">
          </lifedi-card-box>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="suggestNews.length === 0">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
      <div [innerHtml]="newsDetails" id="_content"
        style="line-height: 2; width: 100%; background: white; padding: 30px;">
      </div>
    </div>
  </div>
  <br />
</div>
<lifedi-footer *ngIf="news && suggestNews"></lifedi-footer>
